import { render, staticRenderFns } from "./PreCustomerModal.vue?vue&type=template&id=e64e8ad0&"
import script from "./PreCustomerModal.vue?vue&type=script&lang=js&"
export * from "./PreCustomerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e64e8ad0')) {
      api.createRecord('e64e8ad0', component.options)
    } else {
      api.reload('e64e8ad0', component.options)
    }
    module.hot.accept("./PreCustomerModal.vue?vue&type=template&id=e64e8ad0&", function () {
      api.rerender('e64e8ad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/CustomerMgt/modules/PreCustomerModal.vue"
export default component.exports